import { useHistory } from 'react-router';
import { useFlags } from 'launchdarkly-react-client-sdk';
import useContentQueryManager from 'hooks/useContentQueryParams';
import { getContentCreatePath } from './ContentTable/utils';
import useFeatureSettings from 'hooks/queries/useFeatureSettings';
import { useCustomAuth } from 'auth/AuthContext';
import { ContentTypeForComparison } from 'domains/content/types';

const useGetCreateContentDropdownOptions = () => {
    const history = useHistory();
    const { folderId: parentFolderId } = useContentQueryManager();
    const {
        directMailEditor: hasDirectMailEditorFeature,
        smsEditor: hasSmsEditorFeature,
        voiceCall: hasVoiceCall,
    } = useFlags();

    const { isAuthenticated } = useCustomAuth();

    const { data: featureSettings, isSuccess: isFeatureSettingsSuccess } = useFeatureSettings({
        enabled: isAuthenticated,
    });

    const isSmsEditorEnabled = isFeatureSettingsSuccess && featureSettings?.sms_enabled && hasSmsEditorFeature;

    return [
        {
            label: 'email',
            onClick: () => {
                const path = getContentCreatePath({ contentType: ContentTypeForComparison.EMAIL, parentFolderId });
                history.push(path);
            },
        },
        {
            dataTestId: 'create-landing-page',
            label: 'landing page',
            onClick: () => {
                const path = getContentCreatePath({
                    contentType: ContentTypeForComparison.LANDING_PAGE,
                    parentFolderId,
                });
                history.push(path);
            },
        },
        ...(hasDirectMailEditorFeature
            ? [
                  {
                      label: 'direct mail',
                      onClick: () => {
                          const path = getContentCreatePath({
                              contentType: ContentTypeForComparison.DIRECT_MAIL,
                              parentFolderId,
                          });
                          history.push(path);
                      },
                  },
              ]
            : []),

        ...(isSmsEditorEnabled
            ? [
                  {
                      label: 'sms',
                      onClick: () => {
                          const path = getContentCreatePath({
                              contentType: ContentTypeForComparison.SMS,
                              parentFolderId,
                          });
                          history.push(path);
                      },
                  },
              ]
            : []),
        ...(hasVoiceCall
            ? [
                  {
                      label: 'Voice Call',
                      onClick: () => {
                          const path = getContentCreatePath({
                              contentType: ContentTypeForComparison.VOICE,
                              parentFolderId,
                          });
                          history.push(path);
                      },
                  },
              ]
            : []),
    ];
};

export default useGetCreateContentDropdownOptions;
